import { DashboardHeader } from '@modules/admin/Admin.Header'
import React, { Component } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import { history as browserHistory } from '@services/History'
import AccessControl from '../../auth/AccessControl'
import CustomModal from '../../core/components/CustomModalComponent'
import { PAAS_ADMIN, PROVIDER_ADMIN, SUPER_ADMIN } from '@constants/adminRoles'

class ProfessionalShow extends Component {
  state = {
    id: this.props.match.params.id,
    professional: undefined,
    deleteModal: false,
  }

  clientProfessional = Consultations.professional

  handleToggleModal = () => {
    this.setState((prevState) => ({ deleteModal: !prevState.deleteModal }))
  }

  onDeleteClick = () => {
    this.clientProfessional
      .delete(this.state.id)
      .then(() => browserHistory.push('/professional'))
      .catch((err) => window.alert(err.message))
  }

  componentDidMount() {
    return this.clientProfessional
      .show(this.state.id)
      .then((res) => this.setState({ professional: res.data }))
      .catch((err) =>
        this.setState(undefined, () => {
          throw err
        })
      )
  }

  render() {
    const { professional } = this.state
    const isProd = location.hostname.includes('admin.meetingdoctors.com')
    const url = isProd ? 'https://panel.meetingdoctors.com' : 'https://panel.staging.meetingdoctors.com'
    if (!professional) return null
    return (
      <div className="crud-wrapper professional-wrapper">
        {this.state.deleteModal && (
          <CustomModal
            title={<Trans>¿Estás seguro que quieres borrar este registro?</Trans>}
            active={this.state.deleteModal}
            actionOnClickClose={(active) => this.handleToggleModal(active)}
            actionOnClickAccept={(active) => this.onDeleteClick(active)}
          />
        )}

        <div className="professional-show">
          <DashboardHeader title={<Trans>Profesional</Trans>}>
            {professional.is_editable && (
              <>
                <button className="btn btn-danger" onClick={() => this.handleToggleModal(this.state.deleteModal)}>
                  <Trans>Borrar</Trans>
                </button>

                <Link className="btn btn-primary" to={`/professional/update/${professional.id}`}>
                  <Trans>Editar</Trans>
                </Link>

                <Link className="btn btn-primary" to={`/professional/${professional.id}/schedule`}>
                  <Trans>Horario</Trans>
                </Link>

                <a
                  className="btn btn-primary"
                  href={`${url}/main/professionals/${professional.id}/schedules`}
                  target="_blank"
                >
                  <Trans>Calendario</Trans>
                </a>

                {import.meta.env.VITE_REACT_APP_ENV === 'DEVELOPMENT' && (
                  <Link
                    className="btn btn-primary"
                    to={{
                      pathname: `/relations`,
                      state: this.state.professional,
                    }}
                  >
                    <Trans>Relaciones</Trans>
                  </Link>
                )}
              </>
            )}

            <Link className="btn btn-primary" to={`/professional`}>
              <Trans>Volver</Trans>
            </Link>
          </DashboardHeader>

          <div className="container-fluid main-content">
            <div className="form-crud well">
              {professional.name && (
                <div className="form-group">
                  <label>
                    <Trans>Nombre</Trans>
                  </label>
                  <span>{professional.name}</span>
                </div>
              )}
              {professional.nid_number && (
                <div className="form-group">
                  <label>
                    <Trans>DNI/NIE</Trans>
                  </label>
                  <span>{professional.nid_number}</span>
                </div>
              )}
              {professional.email && (
                <div className="form-group">
                  <label>
                    <Trans>Email</Trans>
                  </label>
                  <span>{professional.email}</span>
                </div>
              )}
              {professional.phone && (
                <div className="form-group">
                  <label>
                    <Trans>Teléfono</Trans>
                  </label>
                  <span>{professional.phone}</span>
                </div>
              )}
              {professional.collegiate_number && (
                <div className="form-group">
                  <label>
                    <Trans>Número de colegiado</Trans>
                  </label>
                  <span>{professional.collegiate_number}</span>
                </div>
              )}
              {professional.avatar && (
                <div className="form-group">
                  <label>
                    <Trans>Avatar</Trans>
                  </label>
                  <img style={{ maxWidth: '100%' }} src={professional.avatar} alt="avatarImage" />
                </div>
              )}
              <AccessControl>
                {professional.companies && professional.companies.length > 0 && (
                  <div className="form-group">
                    <label>
                      <Trans>Compañías</Trans>
                    </label>
                    <span>
                      {professional.companies
                        .map((company) => company.name)
                        .sort()
                        .join(', ')}
                    </span>
                  </div>
                )}
              </AccessControl>
              <AccessControl roles={[SUPER_ADMIN, PAAS_ADMIN, PROVIDER_ADMIN]}>
                <div className="form-group">
                  <label>
                    <Trans>{'professional.type.label'}</Trans>
                  </label>
                  <span>{professional.professional_type || ' - '}</span>
                </div>
                <div className="form-group">
                  <label>Rol del profesional en Workplace</label>
                  <span>
                    {professional.profiles
                      .map((el) => el.name)
                      .toString()
                      .replace(/[,]+/g, ', ')}
                  </span>
                </div>
              </AccessControl>
              {professional.roles && professional.roles.length !== 0 && (
                <div className="form-group">
                  <label>
                    <Trans>Roles</Trans>
                  </label>
                  <span>
                    {professional.roles
                      .map((el) => el.name)
                      .toString()
                      .replace(/[,]+/g, ', ')}
                  </span>
                </div>
              )}
              {professional.access_type && (
                <div className="form-group">
                  <label>
                    <Trans>Tipo de acceso</Trans>
                  </label>
                  <span>{professional.access_type}</span>
                </div>
              )}
              {professional.app_role && (
                <div className="form-group">
                  <label>
                    <Trans>App role</Trans>
                  </label>
                  <span>{professional.app_role.name}</span>
                </div>
              )}
              {professional.speciality && (
                <div className="form-group">
                  <label>
                    <Trans>Especialidad</Trans>
                  </label>
                  <span>{professional.speciality.name}</span>
                </div>
              )}
              {!!professional.teams_ids?.length && (
                <div className="form-group">
                  <label>
                    <Trans>assignedProfessionalGroups</Trans>
                  </label>
                  <span>
                    {professional.teams_ids
                      .map((el) => el.name)
                      .toString()
                      .replace(/[,]+/g, ', ')}
                  </span>
                </div>
              )}
              <AccessControl>
                {professional.provider && (
                  <div className="form-group">
                    <label>
                      <Trans>Proveedor</Trans>
                    </label>
                    <span>{professional.provider.name}</span>
                  </div>
                )}
              </AccessControl>
              {professional.timezone && (
                <div className="form-group">
                  <label>
                    <Trans>Zona horaria / País</Trans>
                  </label>
                  <span>{professional.timezone}</span>
                </div>
              )}

              {professional.countries && professional.countries.length > 0 && (
                <div className="form-group">
                  <label>
                    <Trans>Países activos</Trans>
                  </label>
                  {professional.countries.length < 10 ? (
                    <span>{professional.countries.map((country) => country.name).join(', ')}</span>
                  ) : (
                    <span>
                      <Trans i18nKey="professionalCountries">
                        Activo en <b>{professional.countries.length}</b> países
                      </Trans>
                    </span>
                  )}
                </div>
              )}

              {professional.languages && professional.languages.length > 0 && (
                <div className="form-group">
                  <label>
                    <Trans>Idiomas</Trans>
                  </label>
                  {professional.languages.length < 10 ? (
                    <span>{professional.languages.map((language) => language.name).join(', ')}</span>
                  ) : (
                    <span>
                      <Trans i18nKey="professionalLanguages">
                        Habla en <b>{professional.languages.length}</b> idiomas
                      </Trans>
                    </span>
                  )}
                </div>
              )}

              {professional.title && (
                <div className="form-group">
                  <label>
                    <Trans>Título</Trans>
                  </label>
                  <span>{professional.title}</span>
                </div>
              )}
              {professional.title_html && (
                <div className="form-group">
                  <label>
                    <Trans>Título html</Trans>
                  </label>
                  <span>{professional.title_html}</span>
                </div>
              )}
              {professional.overview && (
                <div className="form-group">
                  <label>
                    <Trans>Descripción</Trans>
                  </label>
                  <span>{professional.overview}</span>
                </div>
              )}

              <div className="form-group">
                <label>
                  <Trans>Visible sin conexión</Trans>
                </label>
                {professional.is_visible_offline ? (
                  <span>
                    <Trans>Este usuario puede aparecer en la lista de contactos si está offline</Trans>
                  </span>
                ) : (
                  <span>
                    <Trans>Este usuario nunca aparecerá en la lista de contactos si está offline</Trans>
                  </span>
                )}
              </div>

              {professional.signature && (
                <div className="form-group">
                  <label>
                    <Trans>Firma</Trans>
                  </label>
                  <img style={{ maxWidth: '100%' }} src={professional.signature} alt="professionalSignature" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(ProfessionalShow)
